import { Box, BoxProps } from "@mui/material";
import { resolveTagColorHex } from "helpers/getColorsTags";

interface Props extends Omit<BoxProps, "color" | "children"> {
  tipo: string;
  cor?: string | null;
  label: string;
}

/** Badge de tag com a cor hex cadastrada (inline style evita override do tema). */
export default function TagColorChip({
  tipo,
  cor,
  label,
  sx,
  ...rest
}: Props) {
  const bg = resolveTagColorHex(tipo, cor);

  return (
    <Box
      component="span"
      {...rest}
      style={{
        backgroundColor: bg,
        color: "#fff",
        border: "none",
      }}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        height: 26,
        px: 1.25,
        borderRadius: "999px",
        fontWeight: 700,
        fontSize: "0.72rem",
        lineHeight: 1,
        whiteSpace: "nowrap",
        maxWidth: "100%",
        ...((sx as object) || {}),
      }}
      title={label}
    >
      {label}
    </Box>
  );
}
